// extracted by mini-css-extract-plugin
export default {"myButton":"MyButton_myButton__PeXuF"};